import('./services/initialize.service')
  .then((module) => {
    module.initApp();
  })
  .catch((error) => {
    console.error('Error loading initialize service:', error);
  });
